module.exports = __webpack_public_path__ + "static/media/openapi.8783175a.yaml";